import type { Config } from 'src/config';

export const isWindowDefined = typeof window !== 'undefined';

export const CONFIG: Config = isWindowDefined ? window.CONFIG : undefined;
